import { __assign, __rest } from "tslib";
import React from 'react';
export var Apps = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: size, height: size }, rest),
        React.createElement("rect", { width: "9", height: "9", x: "2", y: "2", rx: "1" }),
        React.createElement("rect", { width: "9", height: "9", x: "2", y: "13", rx: "1", opacity: "0.6" }),
        React.createElement("rect", { width: "9", height: "9", x: "13", y: "2", rx: "1", opacity: "0.6" }),
        React.createElement("rect", { width: "9", height: "9", x: "13", y: "13", rx: "1", opacity: "0.6" })));
};
//# sourceMappingURL=Apps.js.map